import React, { useEffect } from 'react'
import styled from './CreateOpinionPopup.module.css'
import useEstimateStore from '../stores/estimate'
import axios from 'axios'
import { BASEURL } from '../config'
import useAccountStore from '../stores/account'

const CreateOpinionPopup = (props:any) => {
    const { popRef, showCreateOpinionPopup, setShowCreateOpinionPopup } = props
    const {accessToken} = useAccountStore()
    const {curEsti} = useEstimateStore()
    const [diagnosis, setDiagnosis] = React.useState<string>("") // 진단명
    const [doctorOpinion, setDoctorOpinion] = React.useState<string>("") // 주치의 소견
    const [curOpinion, setCurOpinion] = React.useState<any>(null)
    const [isEdit, setIsEdit] = React.useState<boolean>(false)
    const [isError, setIsError] = React.useState<boolean>(false)
    // 성별 매핑
    const male = '남'
    const female = '여'
    const neuteredMale = '중성화 남'
    const neuteredFemale = '중성화 여'
    const genderMap: { [key: string]: number } = { 
        [male]: 1, [female]: 2, [neuteredMale]: 3, [neuteredFemale]: 4 }
    // 성별 매핑 끝
    useEffect(()=>{
        const getOpinionByEstiID = async(estiID:any) => {    
            const data = await axios.get(`${BASEURL}/opinion?estiID=${estiID}`, {
                headers: {Authorization: `Bearer ${accessToken}`,}
            }).then(response => {
                if (response.data.status === "success") {
                    return response.data.data
                } else { return null }
            }).catch(error => {
                // 등록된 opinion이 없는 상태
                if(error.response.status === 404) return null
                else {
                    alert(`소견서 불러오기 실패`)
                    setIsError(true)
                }
                return null
            })
            if(data) setCurOpinion(data)
        }
        
        if(curEsti) { getOpinionByEstiID(curEsti.id) }
    },[])

    useEffect(()=>{
        setDoctorOpinion(curOpinion?.doctorOpinion)
        setDiagnosis(curOpinion?.diagnosis)
        setIsEdit(curOpinion ? true : false)
    },[curOpinion])

    const handleOpinion = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDoctorOpinion(e.target.value)
    }

    const handleDiagnosis = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDiagnosis(e.target.value)
    }

    const registerOpi = async() => {
        // access token 필요
        if(doctorOpinion === "") {
            alert("진단명을 입력해주세요")
            return false
        }

        if(diagnosis === "") {
            alert("주치의 소견을 입력해주세요")
            return false
        }

        const opinionInfo = {
            estiID: curEsti?.id,
            doctorOpinion: doctorOpinion,
            diagnosis: diagnosis
        }


        const data =  await axios.post(`${BASEURL}/opinion/create`, {opinionInfo:opinionInfo}, {
            headers: {Authorization: `Bearer ${accessToken}`,}
        }).then(response => {
            if (response.data.status === "success") {
                return response.data.data
            } else { return '' }
        }).catch(error => {
            alert(`소견서 등록실패: ${error.message}`)
            return ''
        })
        return data
    }

    const editOpi = async() => {
        // access token 필요
        if(doctorOpinion === "") {
            alert("진단명을 입력해주세요")
            return false
        }

        if(diagnosis === "") {
            alert("주치의 소견을 입력해주세요")
            return false
        }
        if(doctorOpinion === curOpinion?.doctorOpinion && diagnosis === curOpinion?.diagnosis) {
            alert("변경사항이 없습니다.")
            return false
        }

        const opinionInfo = {
            doctorOpinion: doctorOpinion,
            diagnosis: diagnosis
        }


        const data =  await axios.put(`${BASEURL}/opinion/update`, {opinionID:curOpinion?.id, opinionInfo:opinionInfo}, {
            headers: {Authorization: `Bearer ${accessToken}`,}
        }).then(response => {
            // 완료했는지 데이터 유무로 판단
            if (response.data.status === "success") { return response.data.status }
            else { return '' }
        }).catch(error => {
            alert(`소견서 등록실패: ${error.message}`)
            return ''
        })
        return data
    }

    const handleEdit = async() => {
        const isComplete = await editOpi()
        if(isComplete) {
            alert("소견서 수정이 완료되었습니다.")
            setShowCreateOpinionPopup(false)
        }
    }
    const handleRegister = async() => {
        const isComplete = await registerOpi()
        
        if(isComplete) {
            alert("소견서 등록이 완료되었습니다.")
            setShowCreateOpinionPopup(false)
        }
    }   
    const handleAI = async() => {
        const data = {
            이름: curEsti?.userInfo?.petName,
            종: Object.keys(genderMap).find(key => genderMap[key] === curEsti?.userInfo?.petGender) ?? "구분없음",
            나이: curEsti?.userInfo?.petAge,
            진단명: diagnosis,        
        }

        try {
            alert("AI 작성을 진행중입니다. 잠시만 기다려주세요.")
            const response = await axios.post(`${process.env.REACT_APP_PETAI_API_URL}`, data,
                {
                headers: {
                    'Content-Type': 'application/json',
                },}
            )
           
            setDoctorOpinion(response.data.generated_text[0].text ?? "AI 작성 실패")
            
        } catch(e){
            console.error(e)
            alert("AI 작성 실패 - 에러가 발생했습니다.")
        }
    }

    return (
        <div className={styled.create_opinion_pop}
            ref={popRef}
            style={{ 
            bottom: `30px`, 
            right: `50px`, 
            display: showCreateOpinionPopup ? 'block' : 'none' }}>
            <p className={styled.tit}>
                <span className={styled.title}>소견서 {isEdit? "수정하기":"작성하기"}</span>
                <a href="#" className={styled.close_btn} onClick={()=>setShowCreateOpinionPopup(false)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8.94028 7.99988L13.1403 3.80655C13.2658 3.68101 13.3363 3.51075 13.3363 3.33321C13.3363 3.15568 13.2658 2.98542 13.1403 2.85988C13.0147 2.73434 12.8445 2.66382 12.667 2.66382C12.4894 2.66382 12.3192 2.73434 12.1936 2.85988L8.00029 7.05988L3.80695 2.85988C3.68142 2.73434 3.51115 2.66382 3.33362 2.66382C3.15608 2.66382 2.98582 2.73434 2.86028 2.85988C2.73475 2.98542 2.66422 3.15568 2.66422 3.33321C2.66422 3.51075 2.73475 3.68101 2.86028 3.80655L7.06029 7.99988L2.86028 12.1932C2.7978 12.2552 2.7482 12.3289 2.71436 12.4102C2.68051 12.4914 2.66309 12.5785 2.66309 12.6665C2.66309 12.7546 2.68051 12.8417 2.71436 12.9229C2.7482 13.0042 2.7978 13.0779 2.86028 13.1399C2.92226 13.2024 2.99599 13.252 3.07723 13.2858C3.15847 13.3197 3.24561 13.3371 3.33362 13.3371C3.42163 13.3371 3.50876 13.3197 3.59 13.2858C3.67124 13.252 3.74498 13.2024 3.80695 13.1399L8.00029 8.93988L12.1936 13.1399C12.2556 13.2024 12.3293 13.252 12.4106 13.2858C12.4918 13.3197 12.5789 13.3371 12.667 13.3371C12.755 13.3371 12.8421 13.3197 12.9233 13.2858C13.0046 13.252 13.0783 13.2024 13.1403 13.1399C13.2028 13.0779 13.2524 13.0042 13.2862 12.9229C13.3201 12.8417 13.3375 12.7546 13.3375 12.6665C13.3375 12.5785 13.3201 12.4914 13.2862 12.4102C13.2524 12.3289 13.2028 12.2552 13.1403 12.1932L8.94028 7.99988Z" fill="black"/>
                </svg></a>
            </p>
            <div className={styled.section}>
                <div className={styled.column}>
                    <div className={styled.title}>환자이름</div>
                    <div className={styled.obj}>{curEsti?.userInfo?.petName}</div>
                </div>
                <div className={styled.column}>
                    <div className={styled.title}>보호자 성함</div>
                    <div className={styled.obj}>{curEsti?.userInfo?.guardianName}</div>
                </div>
                <div className={styled.column}>
                    <div className={styled.title}>종 / 나이</div>
                    <div className={styled.obj}>{curEsti?.userInfo?.petKind ?? "구분없음"} / {curEsti?.userInfo?.petAge}M</div>
                </div>
                <div className={styled.column}>
                    <div className={styled.title}>성별</div>
                    <div className={styled.obj}>{Object.keys(genderMap).find(key => genderMap[key] === curEsti?.userInfo?.petGender) ?? "구분없음"}</div>
                </div>
                <div className={styled.column}>
                    <div className={styled.title}>진단명</div>
                    <div className={`${styled.obj} ${styled.boldText}`}>                  
                    <textarea className={styled.input_text} onChange={handleDiagnosis} value={diagnosis} />
                    </div>
                </div>
                <div className={styled.column}>
                    <div className={styled.title}>주치의 소견</div>
                    <div className={styled.obj}>
                    <textarea className={styled.input_text} onChange={handleOpinion} value={doctorOpinion}/>
                    </div>
                </div>
            </div>
            <div className={styled.send}>
                <button className={styled.black} disabled={isError} onClick={handleAI}>AI 작성</button>
                {isEdit && <button className={styled.colored} disabled={isError} onClick={handleEdit}>수정하기</button>}
                {!isEdit && <button className={styled.colored} disabled={isError} onClick={handleRegister}>등록하기</button>}
            </div>
        </div>
    )
}

export default CreateOpinionPopup